export const contactRelationships = [
  { id: '', name: '' },
  { id: 'businesspartner', name: 'Business Partner' },
  { id: 'friend', name: 'Friend' },
  { id: 'parent', name: 'Parent' },
  { id: 'relative', name: 'Relative' },
  { id: 'sibling', name: 'Sibling' },
  { id: 'other', name: 'Other' },
];

export const spouseRelationships = [{ id: 'spouse', name: 'Spouse' }];
